import { render, staticRenderFns } from "./moneypay.vue?vue&type=template&id=9196788e&scoped=true&"
import script from "./moneypay.vue?vue&type=script&lang=js&"
export * from "./moneypay.vue?vue&type=script&lang=js&"
import style0 from "./moneypay.vue?vue&type=style&index=0&id=9196788e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9196788e",
  null
  
)

export default component.exports